import { testDateInRange } from '@kit/utils/Date'
import { isWeekday } from './Utils';

//export const CalPolyServiceCode = "WkDy CPH Group"
//export const WkDyRegServiceCode = "WkDy Reg"
//export const SatRegServiceCode = "Sat"

//T3Q460PX493833 SERVICES ///
//export const serviceIDs = ["WkDy Reg", "WkDy CPH Group", "Sat"];
export const serviceIDs = ['WkDy Reg', 'Sat Reg', 'WkDy CPH Group', 'Sat CPH Group', 'SCH Sat CPH', 'Sat'];

// export const serviceIDToColumnName = {
//   "WkDy Reg": "wkdy_reg",
//   "WkDy CPH Group": "wkdy_cph_group",
//   "Sat": "sat",
// };
export const serviceIDToColumnName = {
  "WkDy Reg":'wkdy_reg', 
  "WkDy CPH Group":'wkdy_cph_group', 
  "Sat CPH Group":'sat_cph_group',
  "Sat Reg":'sat_reg',
  "SCH Sat CPH":'sch_sat',
  "Sat":"sat"
};

export const serviceColumnNames = [
  'wkdy_reg', 'wkdy_cph_group', 'sat_cph_group', 'sat_reg', 'sch_sat', 'sat'
]

// export const serviceIDToNiceName = {
//   "WkDy Reg": "Weekday",
//   "WkDy CPH Group": "Weekday CalPoly",
//   "Sat": "Saturday",
// }
export const serviceIDToNiceName = {
  "WkDy Reg": "Weekday",
  "Sat Reg": "Saturday",
  "WkDy CPH Group": "Weekday CalPoly",
  "Sat CPH Group": "Saturday CalPoly",
  "SCH Sat CPH":'SCH Saturday',
  "Sat": "Saturday"
}

const weekdays = {"WkDy Reg": true, "WkDy CPH Group":true }
const saturdays = {"Sat Reg":true, "Sat CPH Group":true, "SCH Sat CPH":true, "Sat":true}
const calpoly = {"WkDy CPH Group":true, "Sat CPH Group":true}
const sch = { "SCH Sat CPH":true }
////////

export const dropoffTypeToMinString = {
  '0': 'Regular.',
  '1': 'Dropoff: None.',
  '2': 'Dropoff: Call ahead.',
  '3': 'Dropoff: Talk to driver.'
}

export const pickupTypeToMinString = {
  '0': 'Regular.',
  '1': 'Pickup: None.',
  '2': 'Pickup: Call ahead.',
  '3': 'Pickup: Talk to driver.'
}



export const isServiceCalPoly = (serviceID) => {
  return !!calpoly[serviceID];
}
export const isServiceWeekday = (serviceID) => {
  return !!weekdays[serviceID]
}


//Check to see if the schedule is CalPoly-only
// export const isScheduleExclusivelyCalPoly = (scheduleRoute) => {
//   const { services } = scheduleRoute
//   if(services.length == 1) {

//     for(let i=0; i<services.length; i++) {
//       const s = services[i]
//       if(!calpoly[s]) {
//        return false
//       }
//     }

//     return true 
//   }
//   return false
// }
export const isScheduleExclusivelyCalPoly = (scheduleRoute) => {
  const { services } = scheduleRoute

  //console.log()

  for(let i=0; i<services.length; i++) {
    const s = services[i]
    if(!calpoly[s]) {
      return false
    }
  }

  return true 
 
}

export const isScheduleExclusivelySat = (scheduleRoute) => {

  const { services } = scheduleRoute
  if(services.length == 1) {

    for(let i=0; i<services.length; i++) {
      const s = services[i]
      if(!saturdays[s]) {
       return false
      }
    }

    return true 
  }
  return false
}


export const getCalPolyService = (scheduleRoute) => {
  const { services } = scheduleRoute

  let weekdayService = null 
  let weekendServce = null

  for(let i=0; i<services.length; i++) {
    const s = services[i]

    if(isServiceCalPoly(s)) {

      //record a weekday and a weekend service
      if(!weekdayService && isServiceWeekday(s)) {
        weekdayService = s
      }
      if(!weekendServce && !isServiceWeekday(s)) {
        weekendServce = s
      }

    }

  }


  //if weekday, then try to return the weekday first,
  //but if one hasn't been found then default to the weekend.
  //The point is that we at least want to show a service no matter what day it is
  if(isWeekday()) {
    return weekdayService || weekendServce
  } else {
    return weekendServce || weekdayService
  }
}


export const getNonCalPolyService = (scheduleRoute) => {
  const { services } = scheduleRoute

  let weekdayService = null 
  let weekendServce = null

  for(let i=0; i<services.length; i++) {
    const s = services[i]

    if(!isServiceCalPoly(s)) {

      //record a weekday and a weekend service
      if(!weekdayService && isServiceWeekday(s)) {
        weekdayService = s
      }
      if(!weekendServce && (!isServiceWeekday(s) || sch[s])) {
        weekendServce = s
      }

    }

  }

  //if weekday, then try to return the weekday first,
  //but if one hasn't been found then default to the weekend.
  //The point is that we at least want to show a service no matter what day it is
  if(isWeekday()) {
    return weekdayService || weekendServce
  } else {
    return weekendServce || weekdayService
  }

}



/**
   @param calpolyDates 
    {
      <a-date-code>: {
        "date_name": "2026 Fall Break",
        "date_description": "November 24 thru November 30<br>\r\n<b>* HHM Express Runs This Week Per The Holiday Schedule Above<\/b>",
        "start_date": "2026-11-24",
        "end_date": "2026-11-30",
        "date_code": "fall-break",
        "ID": 2484,
        "guid": "https:\/\/localhost\/cms-service\/?post_type=calpoly_date&#038;p=2484",
        "post_type": "calpoly_date",
        "id": 2484
      },
      ...
    }


   The date-codes are as follows:
   fall-break
   spring-break
   summer-break
   fall-semester-insession
   spring-semester-insession

  @param scheduleRoute 
  composite CMS and GTFS route object
    {
        "route_id": "A Gold",
        "agency": "redwood",
        "news_stories": [
            {
                "ID": "2721",
                "guid": "https://localhost/cms-service/?post_type=news_clip&#038;p=2721",
                "post_type": "news_clip",
                "pod_item_id": "2721"
            }
        ],
        "show_calpoly_schedule": "1",
        "holidays_and_calendar_url": "/how-to-ride/holidays",
        "holidays_and_calendar_link_text": "See HTA Holidays",
        "hta_service_provider": {
            "ID": "274",
            "guid": "https://localhost/cms-service/?post_type=sprovider_brief&#038;p=274",
            "post_type": "hta_service_provider",
            "pod_item_id": "274"
        },
        "hta_service_provider_slug": "arcata-and-mad-river",
        "ID": 142,
        "guid": "https://localhost/cms-service/?post_type=hta_route&#038;p=142",
        "post_type": "hta_route",
        "id": 142,
        "wkdy_reg": 1,
        "wkdy_cph_group": 1,
        "sat": null,
        "services": [
            "WkDy CPH Group",
            "WkDy Reg"
        ],
        "color": "#ffcc33",
        "text_color": "#000000",
        "aria_color": "#ffcc33",
        "aria_text_color": "#000000",
        "display_name": "A Gold",
        "display_name_short": "A Gold",
        "display_name_long": "Arcata Gold Loop",
        "route_desc": "The Arcata Gold Loop operates within the City of Arcata Monday through Friday. It serves downtown Arcata, CalPoly Humboldt, Valley West Shopping Center, and Alliance Rd."
    }


  Many of the routes come with a service labelled "WkDy CPH Group", but they don't actually
  have it. There's an additional flag in the schedule data called show_calpoly_schedule 
  that tells us whether or not it actually has a calpoly schedule.

  If it actually has one, then what we have to do is perform a date comparison with these rules:

  (See "Meeting-notes 2026-05-07 Jerome.md")

  CalPoly Schedule is APPLICABLE DURING:
  2025 Spring Semester In-Session. January 15 thru May 16
  BUT it reverts to NORMAL SCHEDULE during:
  2026 Spring Break
  March 16 thru March 22

  CalPoly Schedule is APPLICABLE DURING:
  2025 Fall Semester In-Session
  August 18 thru December 21
  BUT it reverts to NORMAL SCHEDULE during:
  2025 Fall Break
  November 24 thru November 30


 */
export const isScheduleInCalPolySession = (calpolyDates, scheduleRoute) => {

  //If there's only one service in the route and it's cal-poly, then we're going to just return 
  //that service code no matter what.
  if(isScheduleExclusivelyCalPoly(scheduleRoute) && scheduleRoute.services.length == 1) {
    return true
  }

  if(scheduleRoute.show_calpoly_schedule == '1') {

    const fallInSession = calpolyDates['fall-semester-insession']
    const springInSession = calpolyDates['spring-semester-insession']
    const fallBreak = calpolyDates['fall-break']
    const springBreak = calpolyDates['spring-break']

    //Testing this
    //const testDate = '2026-06-04' //you have to add this in after the end_date parameters
    //springBreak['start_date'] = '2026-05-20'
    //springBreak['end_date'] = '2026-06-20'
    // springBreak['start_date'] = '2026-07-20'
    // springBreak['end_date'] = '2026-07-24'
    // springInSession['start_date'] = '2026-05-01'
    // springInSession['end_date'] = '2026-08-01'

    const inFallSession = testDateInRange(fallInSession['start_date'], fallInSession['end_date'])
    const inSpringSession = testDateInRange(springInSession['start_date'], springInSession['end_date'])

    const inFallBreak = testDateInRange(fallBreak['start_date'], fallBreak['end_date'])
    const inSpringBreak = testDateInRange(springBreak['start_date'], springBreak['end_date'])

    const showCalPolyButton = (inFallSession && !inFallBreak) || (inSpringSession && !inSpringBreak)

    // console.log("*****************************************************************")
    // console.log("im going to hack this thing so that it shows up.")
    // console.log('inFallBreak:'+ inFallBreak)
    // console.log('inFallSession:'+ inFallSession)
    // console.log('inSpringSession:'+ inSpringSession)
    // console.log('inSpringBreak:'+ inSpringBreak)
    // console.log('showCalPolyButton:'+ showCalPolyButton)

    return showCalPolyButton

  } 

  return false

}


export const getDefaultServiceID = (calpolyDates, scheduleRoute, isWeekday) => {
  
  let calPoly = null
  if(isScheduleInCalPolySession(calpolyDates, scheduleRoute)) {
    const s = getCalPolyService(scheduleRoute)
    calPoly = s
  } 
    
  const regular = getNonCalPolyService(scheduleRoute)
  const serviceID = calPoly || regular 
  return serviceID


}
